import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading} from "includes/Heading.js";
import { PrimaryButton as PrimaryButtonBase } from "includes/Buttons.js";
import {postRequest} from "../helpers/ApiHelper";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);
const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`;
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`;
const Textarea = styled(Input).attrs({as: "textarea"})`
  ${tw`h-24`}
`;
const MySwal = withReactContent(Swal)
const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`;

export default class ContactForm extends React.Component {

  title;
  image;
  description = "";
  submitButtonText = "Send";
  formAction = "#";
  formMethod = "get";
  textOnLeft = true;
  state = {
    contact:{
      name:'',
      email:'',
      subject:'',
      message:'',
    }
  };

  constructor(props) {
    super(props);
    this.title = props.fieldData.title;
    this.image = props.fieldData.image;
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }
  handleInputChange(type,event) {
    const contact = this.state.contact;
    contact[type] = event.target.value;

    this.setState({
      contact:contact
    });
  }
  onFormSubmit(e) {
    e.preventDefault();
    if(true){
      const data = this.state.contact;
      postRequest('contact-post',data).then(res => {
        MySwal.fire({
          title:"",
          text:"Query Submiited wi will contact you soon",
        });
      },error => {

      });

    }

  }

  render() {
    return (
        <Container>
          <TwoColumn>
            <ImageColumn>
              <Image imageSrc={this.image} />
            </ImageColumn>
            <TextColumn textOnLeft={true}>
              <TextContent>
                <Heading>{this.title}</Heading>
                <Form onSubmit={ this.onFormSubmit }>
                  <Input type="text" name="name" placeholder="Full Name"
                         value={this.state.contact.name}
                         onChange={ (e) => {this.handleInputChange('name',e)} } />
                  <Input type="email" name="email" placeholder="Your Email Address" value={this.state.contact.email}
                         onChange={ (e) => {this.handleInputChange('email',e)} } />
                  <Input type="text" name="subject" placeholder="Subject" value={this.state.contact.subject}
                         onChange={ (e) => {this.handleInputChange('subject',e)} } />
                  <Textarea name="message" placeholder="Your Message Here" value={this.state.contact.message}
                            onChange={ (e) => {this.handleInputChange('message',e)} } />
                  <SubmitButton type="submit">{this.submitButtonText}</SubmitButton>
                </Form>
              </TextContent>
            </TextColumn>
          </TwoColumn>
        </Container>
    );
  }
}
